import _ from 'lodash';
import { User } from '../../types';

export const getUserAndTokenFromSearchParams = (
	searchParams: string
): { user: User; token: string } | null => {
	searchParams = searchParams.replace(/^\?/, '');
	if (!searchParams.includes('token') || !searchParams.includes('user')) {
		return null;
	}

	const param = _.fromPairs(
		searchParams
			.split('&')
			.filter(Boolean)
			.map(pair => {
				const parts = pair.split('=');
				const [key, value] = parts;
				if (key === 'token') {
					return [key, value];
				} else {
					return [key, JSON.parse(decodeURIComponent(value))];
				}
			})
	);

	return param;
};